import React, { useState, useEffect, useMemo } from 'react';
import axios from 'axios';
import styles from './pn.module.css';

const ProjectNetworkMessages = ({ onProfileClick }) => {
    const [profiles, setProfiles] = useState([]);
    const [userId1, setUserId1] = useState('');    
    const token = useMemo(() => localStorage.getItem('token'), []);

    useEffect(() => {
        const fetchProjectNetworks = async () => {
            try {
                const response = await axios.get('/api/applicant/messages/all-networks', {
                    headers: {
                        Authorization: `Bearer ${token}`
                    }
                });
                setProfiles(response.data.projectNetworkList);
                setUserId1(response.data.userId);
                // console.log('Project Networks:', response.data);
            } catch (error) {
                // console.error('Error fetching project networks:', error);
            }
        };

        fetchProjectNetworks();
    }, []);

    return (
        <div className={styles.container}>
            <div className={styles.pn}>
            <h3>Project Network Messages</h3>
            <ul >
                {profiles.map(profile => (
                    <li key={profile.id} onClick={() => onProfileClick(profile)}>
                        <img 
                            src={profile.profilePicture ? profile.profilePicture.replace('/upload/', '/upload/w_192,h_200,c_fill/') : '/default-profile.png'}
                            alt={profile.name}
                        />
                        {profile.name}
                    </li>
                ))}
            </ul>
            </div>
        </div>
    );
};

export default ProjectNetworkMessages;